import { render, staticRenderFns } from "./SettlementRules.vue?vue&type=template&id=104a6ed0"
import script from "./SettlementRules.vue?vue&type=script&lang=js"
export * from "./SettlementRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports